/**
 * Does the address name a record the page is about to scroll to (`?focus=`)?
 *
 * Read from `window.location` at the moment of asking, because the route's own
 * scroll-to-top (App.tsx, PageTransition) runs in the same commit as the page
 * that will position itself, and must stand aside for it — otherwise its late
 * passes land after useFocusParam's scroll whenever the list was cached.
 *
 * Its own module with no imports: App.tsx is the entry chunk, and importing
 * the hook from there pulled the URL-state hooks into every first load.
 */
export function focusPending(param = "focus"): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).has(param);
}
